import React, { Component } from 'react';
import classnames from 'classnames';
import Image from 'app/components/image/Image';
import AdHeader from './adheader/AdHeader';
import AdFooter from './adfooter/AdFooter';
import RegistrationForm from './registrationform/RegistrationForm';
import RegistrationStyles from './scss/RegistrationStyles.module.scss';
import { callables as StoreMethods } from 'app/store/Store';
import Model from 'app/modules/model/Model';
import Helpers from 'app/utils/helpers/Helpers';
import GoogleAnalytics from 'app/utils/googleanalytics/GoogleAnalytics';

// Start Bryan
const companyMap = {
	'bestprofit_futures': {
		full: 'PT Bestprofit Futures',
		abbr: 'BPF'
	},
	'equityworld_futures': {
		full: 'PT Equityworld Futures',
		abbr: 'EWF'
	},
	'kontakperkasa_futures': {
		full: 'PT Kontakperkasa Futures',
		abbr: 'KPF'
	},
	'rifanfinancindo_berjangka': {
		full: 'PT Rifanfinancindo Berjangka',
		abbr: 'RFB'
	},
	'solidgold_berjangka': {
		full: 'PT Solidgold Berjangka',
		abbr: 'SGB'
	}
};

class Registration extends Component {

	constructor(props) {
		super(props);
		this.state = {
			show_privacy_modal: false,
		};
	}

	componentDidMount = () => {
		GoogleAnalytics.page_view([], 'Registration Page');
	}

	openPrivacyModal = () => {
		this.setState({ show_privacy_modal: true });
	};

	closeModals = () => {
		this.setState({
			show_privacy_modal: false,
		});
	};

	render() {
		const companyName = process.env.REACT_APP_COMPANYNAME;
		const companyData = companyMap[companyName] || companyMap['kontakperkasa_futures'];
		const has_AdHeader = !Helpers.is_empty(this.props.CompanyAds) && this.props.CompanyAds.content
			&& this.props.CompanyAds.content.main;

		return (
			<div className={!has_AdHeader && RegistrationStyles.has_no_AdHeader}>
				<div className={classnames([
					RegistrationStyles.header,
					'AppStyles-container'
				])}
				>
					<div className={RegistrationStyles.logo_container}>
						<Image.Logo />
					</div>
				</div>
				<div
					className={classnames([
						RegistrationStyles.body,
						'GlobalStyles-slant_container_secondary'
					])}
				>
					<div
						className={classnames([
							RegistrationStyles.body_background,
							'GlobalStyles-slant_container_background'
						])}
					>
					</div>
					<div className={RegistrationStyles.body_content_wrapper}>
						<div
							className={classnames([
								RegistrationStyles.form_container,
								RegistrationStyles.main_display_boundary
							])}
						>
							<div className={classnames([
								RegistrationStyles.main_display,
								'.RegistrationStyles-form_main_display'
							])}
							>
								<RegistrationForm
									onOpenTerms={this.openTermsModal}
									onOpenPrivacy={this.openPrivacyModal}
								/>
							</div>
						</div>
						<div
							className={classnames([
								RegistrationStyles.adheader_container,
								RegistrationStyles.main_display_boundary
							])}
						>
							<div className={RegistrationStyles.main_display}>
								<AdHeader />
							</div>
						</div>
					</div>
				</div>
				<div className={RegistrationStyles.adfooter_wrapper}>
					<div
						className={classnames([
							RegistrationStyles.adfooter_container,
							'AppStyles-container'
						])}
					>
						<AdFooter />
					</div>
				</div>

				{this.state.show_privacy_modal && (
					<div className={RegistrationStyles.modalOverlay}>
						<div className={RegistrationStyles.modalContentLarge}>
							<div className={RegistrationStyles.modalHeader}>
								<h3>Kebijakan Privasi</h3>
								<button
									className={RegistrationStyles.closeButton}
									onClick={this.closeModals}
								>
									×
								</button>
							</div>
							<div className={RegistrationStyles.modalBody}>
								<p>
									Kebijakan Privasi ini menjelaskan bagaimana {companyData.full} mengumpulkan,
									menggunakan, menyimpan, dan melindungi data pribadi Anda saat menggunakan
									website dan layanan kami.
								</p>

								<p><strong>Tanggal Berlaku:</strong> 14 Februari 2026</p>

								<h4>1. Informasi yang Kami Kumpulkan</h4>
								<ul>
									<li>
										Informasi identitas dan kontak yang Anda berikan secara sukarela ketika
										berinteraksi dengan layanan kami, termasuk nama, email, nomor telepon,
										dan data dokumen pada proses pembukaan akun.
									</li>
									<li>
										Data teknis saat mengakses website, seperti alamat IP, jenis browser,
										sistem operasi, halaman yang diakses, serta waktu akses untuk kebutuhan
										keamanan dan operasional.
									</li>
									<li>
										Data transaksi dan komunikasi terkait layanan perdagangan berjangka
										sesuai ketentuan regulator yang berlaku.
									</li>
								</ul>

								<h4>2. Cara Kami Menggunakan Informasi</h4>
								<ul>
									<li>
										Memproses permintaan Anda, termasuk pendaftaran, verifikasi, layanan
										nasabah, serta penyampaian informasi operasional.
									</li>
									<li>
										Menjalankan kewajiban hukum, kepatuhan, audit internal, dan pelaporan
										kepada otoritas terkait.
									</li>
									<li>
										Meningkatkan performa, keamanan, dan pengalaman pengguna pada website
										serta layanan digital {companyData.full}.
									</li>
								</ul>

								<h4>3. Pengungkapan Informasi</h4>
								<ul>
									<li>Kami tidak menjual data pribadi Anda.</li>
									<li>
										Informasi dapat dibagikan kepada pihak ketiga yang relevan untuk
										operasional layanan, kewajiban hukum, dan kepatuhan regulator.
									</li>
									<li>
										Dalam kondisi tertentu, kami dapat mengungkapkan informasi apabila
										diwajibkan oleh hukum atau permintaan resmi dari instansi berwenang.
									</li>
								</ul>

								<h4>4. Cookie dan Teknologi Pihak Ketiga</h4>
								<ul>
									<li>
										Website ini dapat menggunakan cookie untuk menjaga sesi, preferensi
										bahasa, dan peningkatan performa.
									</li>
									<li>
										Website kami juga memuat layanan pihak ketiga seperti Google Maps,
										TradingView, YouTube, dan TikTok yang memiliki kebijakan privasi
										masing-masing.
									</li>
									<li>
										Anda dapat mengatur cookie melalui browser, namun beberapa fitur mungkin
										tidak berfungsi secara optimal.
									</li>
								</ul>

								<h4>5. Keamanan Data</h4>
								<ul>
									<li>
										Kami menerapkan langkah teknis dan organisasi yang wajar untuk
										melindungi data dari akses, perubahan, atau pengungkapan tanpa izin.
									</li>
									<li>
										Meskipun demikian, tidak ada metode transmisi data melalui internet
										yang sepenuhnya bebas risiko.
									</li>
								</ul>

								<h4>6. Hak Anda</h4>
								<ul>
									<li>
										Anda dapat mengajukan permintaan akses, pembaruan, atau koreksi data
										pribadi sesuai peraturan yang berlaku.
									</li>
									<li>
										Untuk permintaan terkait privasi data, silakan hubungi kami melalui
										kontak resmi yang tersedia.
									</li>
								</ul>

								<h4>7. Perubahan Kebijakan Privasi</h4>
								<ul>
									<li>
										Kebijakan Privasi ini dapat diperbarui sewaktu-waktu untuk menyesuaikan
										perubahan layanan, teknologi, atau regulasi.
									</li>
									<li>
										Versi terbaru akan dipublikasikan pada halaman ini dengan tanggal
										berlaku terbaru.
									</li>
								</ul>
							</div>
						</div>
					</div>
				)}
				{/* End Bryan */}
			</div>
		);
	}
}

export default StoreMethods.connect_stores(Registration, ['CompanyAds'], Model.get_company_ads);
